import '../../sass/blocks/colours.scss';

(() => {
    const $colours = document.querySelectorAll('.colours');

    if (!$colours) return;

    $colours.forEach($colour => {
        const $colourCopyValues = $colour.querySelectorAll('.colours__colour-copy-value');

        const initColourCopyValues = () => {
            if (!$colourCopyValues) return;

            $colourCopyValues.forEach($colourCopyValue => {
                const { copyValue } = $colourCopyValue.dataset;

                $colourCopyValue.addEventListener('click', async () => {
                    try {
                      await navigator.clipboard.writeText(copyValue);
                      console.log('Content copied to clipboard');
                    } catch (err) {
                      console.error('Failed to copy: ', err);
                    }
                });
            });
        };

        initColourCopyValues();
    });
})();
